import React from 'react'
import PropTypes from 'prop-types'
import styles from 'layouts/WideLayout/WideLayout.module.scss'
import Button from 'gu-ui-kit/Button'
import Icon from 'gu-ui-kit/Icon'

export const CloseButton = ({ onClose = () => {} }) => (
  <Button
    noLabel
    bgColor={'Interface-Onsurface'}
    bgColorActive={'Interface-Onsurface'}
    bgColorFocus={'Interface-Onsurface'}
    bgColorHover={'Interface-Onsurface'}
    borderColor={'Interface-Onsurface'}
    borderColorActive={'Interface-Onsurface'}
    borderColorFocus={'Interface-Onsurface'}
    borderColorHover={'Interface-Onsurface'}
    className={styles['layout__close-button']}
    color={'Interface-Eighth'}
    colorActive={'Interface-Ten'}
    colorFocus={'Interface-Eleven'}
    colorHover={'Interface-Nine'}
    size={'s'}
    startIcon={<Icon name={'undo'} />}
    variant={'ghost'}
    onClick={onClose}
  />
)

CloseButton.propTypes = {
  onClose: PropTypes.func,
}
